import {useContext, useEffect} from "react";
import {useQuery} from "@tanstack/react-query";
import {getNewTopCategories, getProducts} from "../../api/catalog";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {ProductTypeId} from "../../interfaces/catalog/ApiRequestInterface";
import CatelogBase from "./CatalogBase";

// все новинки; плитки сверху — категории первого уровня, в которых есть новинки (как /catalog/top-new на pride.ru)
export default function CatalogNew() {

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const {data: response, status} = useQuery({
        queryKey: ['new-products', state.customer?.id],
        queryFn: () => getProducts({typeId: ProductTypeId.New}, state.customer),
        //@ts-ignore
        retry: !window.NOSCRIPT ? false : 1,
    })

    const {data: newCategories} = useQuery({
        queryKey: ['top-categories-new'],
        queryFn: () => getNewTopCategories(),
    })

    useEffect(() => {
        switch (status) {
            case 'pending':
                dispatch({type: ReducerActionType.LOAD})
                return;
            case 'error':
                dispatch({type: ReducerActionType.ERROR, payload: 'При загрузке товаров возникли ошибки'})
                return;
            case 'success':
                dispatch({type: ReducerActionType.SUCCESS})
                return;
        }
    }, [status]);

    useEffect(() => {
        dispatch({type: ReducerActionType.SET_BREADCRUMBS, payload: [{name: 'Новинки'}]})
    }, [response]);

    return (<>{response && <CatelogBase response={{...response, subCategories: newCategories?.categories.map(item => item.category) || []}}
                                        header={''} headerPrefix={<span className="t-orange">Новинки</span>} baseUrl={'/catalog/new'} categoryBaseUrl={'/catalog/new'}/>}</>);
}
